import { render, staticRenderFns } from "./WithdrawAcc.vue?vue&type=template&id=05e25ea3&scoped=true"
import script from "./WithdrawAcc.vue?vue&type=script&lang=js"
export * from "./WithdrawAcc.vue?vue&type=script&lang=js"
import style0 from "./WithdrawAcc.vue?vue&type=style&index=0&id=05e25ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e25ea3",
  null
  
)

export default component.exports